<template>

</template>

<script>
    export default {
        name: "transfer",
        data(){
          return{

          }
        },
      created(){
          //返回重定向
          // if(this.$store.state.isLogin == 1 && this.$route.params.address){
          //   this.$router.push("/");
          // }
          //是否需要授权登录
        if(this.$route.params.address){
            var that = this;
            this.$api.get("",{
              api:'/api/proxy/menhu_login_verify',
              v_key: this.$route.params.v_key,
              token: this.$route.params.token,
              salt: this.$route.params.salt
            },res=>{
              if(res.status == 1){
                this.$store.commit("setLogin");
                that.tools.setStorage('expire_time', res.data.data.expire_time, res.data.data.expire_time);
                that.tools.setStorage('mooc_user_token',res.data.data.user_token,res.data.data.expire_time);
                that.tools.setStorage('mooc_user_id',res.data.data.mooc_user_id,res.data.data.expire_time);
                that.tools.setStorage('mooc_user_salt',res.data.data.salt,res.data.data.expire_time);
                that.tools.setStorage('center_id',res.data.data.center_id,res.data.data.expire_time);
                that.tools.setStorage('user_type',res.data.data.user_type,res.data.data.expire_time);
                that.tools.setStorage('center_key',res.data.data.center_key,res.data.data.expire_time);
                if(this.$route.params.address=='index'){
                  window.location.replace('/mooc-wx/' + this.$route.params.address.replace('*','').replace(/\*/g,'/')+'?v_key='+this.$route.params.v_key);
                }else {
                  window.location.replace('/' + this.$route.params.address.replace('*','').replace(/\*/g,'/')+'?v_key='+this.$route.params.v_key);
                }
                // window.location.replace('/mooc-wx/' + this.$route.params.address.replace('*','').replace(/\*/g,'/')+'?v_key='+this.$route.params.v_key);
                //this.$store.commit("setfirstlink");
                // this.$router.replace('/' + this.$route.params.address.replace('*','').replace(/\*/g,'/'));
              }else{
                console.log('shibai');
              }
            })
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/transfer/transfer.vue